const StatusUser=[
    { value: "0", label: "Admin" },
    { value: "1", label: "Directeur commercial" },
    { value: "2", label: "Chef de vente" },
    { value: "3", label: "Telepro/Commercial" },
  ];

export default StatusUser;
